import React from 'react';

const SvgHome = props => {
  return (
    <svg width={'100%'} viewBox="0 0 32 32" {...props}>
      <defs>
        <style>
          {'.home_svg__a{fill:none;stroke:#ff9000;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}'}
        </style>
      </defs>
      <path
        className="home__a"
        style={{ stroke: props.color, fill: 'none', strokeWidth: props.stroke || 2 }}
        d="M3 4h11v10H3zM18 4h11v10H18zM3 18h11v10H3zM18 18h11v10H18z"
      />
      <path fill="none" d="M0 0h32v32H0z" />
    </svg>
  );
};

export default SvgHome;
